import React, { useState, useEffect, useRef, useContext } from 'react';

const spinList = [
    {
        name: "promo",
        img: "/img/0.webp"
    },
    {
        name: "common",
        img: "/img/1.webp"
    },
    {
        name: "uncommon",
        img: "/img/2.webp"
    },
    {
        name: "rare",
        img: "/img/3.webp"
    },
    {
        name: "epic",
        img: "/img/4.webp"
    },
    {
        name: "legendary",
        img: "/img/5.webp"
    }
]

const runesList = [
    {
        name: "promo",
        img: "/img/runes/0.webp"
    },
    {
        name: "common",
        img: "/img/runes/1.webp"
    },
    {
        name: "uncommon",
        img: "/img/runes/2.webp"
    },
    {
        name: "rare",
        img: "/img/runes/3.webp"
    },
    {
        name: "epic",
        img: "/img/runes/4.webp"
    },
    {
        name: "legendary",
        img: "/img/runes/5.webp"
    }
]

const loop = (list, typeModal, addNew, number, changeSpin, indexMoldaSpin) => {
    return list.map((item) => (
        <div className="one-choose-nft">
            <span>
                <img src={item.img} alt={item.name} />
            </span>
            {typeModal === "new" ? (
                <div className="hover-pl" onClick={() => addNew(item.name, number)}><span></span></div>
            ) : (
                <div className="hover-pl" onClick={() => changeSpin(item.name, indexMoldaSpin)}><span></span></div>
            )}
        </div>
    ));
}

function ModalChooseComponent({ openModal, typeModal, items, addNew, changeSpin, indexMoldaSpin }) {

    const [number, setNumber] = useState(1);

    const handleChange = (event) => {
        setNumber(event.target.value);
    };

    return (
        <div className="modal choose-spin-runes">
            <div className="modal-in">
                <div className="modal-body">
                    <div className="close-modal" onClick={() => openModal(false)}></div>
                    <div className="modal-title">
                        {typeModal === "new" ? "Choose spinney" : "Change spinney"}
                    </div>
                    {typeModal === "new" ?
                        <div className='many-add'>
                            <div className="many-add-name">
                                how many spins do you want to add at a time?
                            </div>
                            <input type="number" value={number} onChange={handleChange} />
                        </div> : null}
                    <div className="modal-wrap">
                        {typeModal === "new" ?
                            loop(spinList, typeModal, addNew, number, changeSpin, indexMoldaSpin)
                            :
                            loop(spinList, typeModal, addNew, number, changeSpin, indexMoldaSpin)
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalChooseComponent;
